import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class MobileSettingsService {
  constructor(private http: HttpClient) {}

  public fetchMobileSettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_MOBILE`
    return this.http.get(url, {})
  }

  public updateMobileSettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_MOBILE`
    return this.http.put(url, payload)
  }
}
